(() => {
  if (window.__dukAlgoliaSearchPageInitialized) return;
  const CONFIG = {
    hitsPerPage: 48,
    collectionHitsPerPage: 1000,
    debounceMs: 280,
    timeout: 3000,
    debug: false,
    tabs: [
      { key: 'products', label: { de: 'Produkte', en: 'Products' } },
      { key: 'series', label: { de: 'Serien', en: 'Series' } },
      { key: 'brands', label: { de: 'Marken', en: 'Brands' } },
      { key: 'stores', label: { de: 'Geschäfte', en: 'Stores' } },
      { key: 'categories', label: { de: 'Kategorien', en: 'Categories' } },
      { key: 'editorials', label: { de: 'Editorials', en: 'Editorials' } },
      { key: 'teamPicks', label: { de: 'Team Picks', en: 'Team Picks' } }
    ],
    facets: [
      { key: 'brand', label: { de: 'Marke', en: 'Brand' }, candidates: ['vendor', 'brand'] },
      { key: 'productType', label: { de: 'Produkttyp', en: 'Product type' }, candidates: ['product_type', 'type', 'productType'] },
      { key: 'scentFamily', label: { de: 'Duftfamilie', en: 'Scent family' }, candidates: ['meta.custom.scent_family', 'metafields.custom.scent_family', 'scent_family'] },
      { key: 'primaryNote', label: { de: 'Primäre Note', en: 'Primary note' }, candidates: ['meta.custom.primary_note', 'metafields.custom.primary_note', 'primary_note'] }
    ],
    inStockCandidates: ['inventory_available', 'available', 'in_stock', 'variants_inventory_count']
  };

  const state = {
    client: null,
    requestId: 0,
    query: '',
    activeTab: 'products',
    activeFacetAttributes: {},
    selectedFacets: {},
    inStock: false,
    lastFacets: {},
    products: { page: 0, nbHits: 0, nbPages: 0, hits: [], activeIndexName: '' },
    series: { page: 0, nbHits: 0, hits: [], activeIndexName: '' },
    brands: { page: 0, nbHits: 0, hits: [], activeIndexName: '' },
    stores: { page: 0, nbHits: 0, nbPages: 0, hits: [], activeIndexName: '' },
    categories: { page: 0, nbHits: 0, hits: [], activeIndexName: '' },
    editorials: { page: 0, nbHits: 0, hits: [], activeIndexName: '' },
    teamPicks: { page: 0, nbHits: 0, hits: [], activeIndexName: '' }
  };

  const log = (...args) => CONFIG.debug && console.info('[DUK Algolia search page]', ...args);
  const warn = (...args) => CONFIG.debug && console.warn('[DUK Algolia search page]', ...args);

  const els = {};

  function injectStyles() {
    if (document.getElementById('duk-algolia-search-page-styles')) return;

    const style = document.createElement('style');
    style.id = 'duk-algolia-search-page-styles';
    style.textContent = `
      [data-algolia-search-page] { position: relative; }

      [data-algolia-search-page]::before {
        content: '';
        position: sticky;
        top: 0;
        z-index: 3;
        display: block;
        width: 100%;
        height: 1px;
        background: currentColor;
        opacity: 0;
        transform: scaleX(0);
        transform-origin: left center;
        transition: transform .45s ease, opacity .2s ease;
      }

      [data-algolia-search-page].is-loading::before {
        opacity: .22;
        transform: scaleX(1);
      }

      [data-algolia-search-page] > .container.section-spacing { padding-block-start: 1rem; }

      .algolia-search-page .collection__resource-tab-list {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
      }

      .algolia-search-page [data-algolia-search-tab][hidden],
      .algolia-search-page [data-algolia-search-panel][hidden] {
        display: none !important;
      }

      .algolia-search-page .product-list,
      .algolia-search-page__collection-list {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--container-gutter);
      }

      .algolia-search-page .product-card__media,
      .algolia-search-page__collection-card-media {
        display: block;
        aspect-ratio: 4 / 5;
        overflow: hidden;
      }

      .algolia-search-page .product-card__image,
      .algolia-search-page__collection-card-media img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .algolia-search-page__collection-card {
        display: block;
        min-width: 0;
        text-decoration: none;
      }

      .algolia-search-page__collection-card-info {
        display: grid;
        gap: .15rem;
        margin-block-start: .65rem;
      }

      @media (prefers-reduced-motion: no-preference) {
        .algolia-search-page .product-list > .product-card,
        .algolia-search-page__collection-list > .algolia-search-page__collection-card {
          animation: duk-algolia-search-card-reveal .18s ease-in-out both;
        }

        .algolia-search-page .product-list > :nth-child(2),
        .algolia-search-page__collection-list > :nth-child(2) { animation-delay: .05s; }

        .algolia-search-page .product-list > :nth-child(3),
        .algolia-search-page__collection-list > :nth-child(3) { animation-delay: .1s; }

        .algolia-search-page .product-list > :nth-child(n + 4),
        .algolia-search-page__collection-list > :nth-child(n + 4) { animation-delay: .15s; }
      }

      @keyframes duk-algolia-search-card-reveal {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }

      .algolia-search-page__link-list {
        display: grid;
        gap: .75rem;
      }

      .algolia-search-page__link-list a {
        display: inline;
        line-height: 1.2;
      }

      .algolia-search-page__filter-empty { margin-block: 1rem; }

      #algolia-search-page-load-more-wrap,
      #algolia-search-page-series-load-more-wrap,
      #algolia-search-page-brands-load-more-wrap,
      #algolia-search-page-stores-load-more-wrap,
      #algolia-search-page-categories-load-more-wrap,
      #algolia-search-page-editorials-load-more-wrap,
      #algolia-search-page-team-picks-load-more-wrap {
        margin-block-start: 3rem;
      }

      @media screen and (min-width: 700px) {
        .algolia-search-page .product-list,
        .algolia-search-page__collection-list {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
      }

      @media screen and (min-width: 1000px) {
        .algolia-search-page .product-list,
        .algolia-search-page__collection-list {
          grid-template-columns: repeat(4, minmax(0, 1fr));
        }
      }
    `;

    document.head.appendChild(style);
  }

  function cacheElements() {
    els.root = document.querySelector('[data-algolia-search-page]');
    els.input = document.getElementById('algolia-search-page-input');
    els.count = document.getElementById('algolia-search-page-count');
    els.filterButton = document.getElementById('algolia-search-page-filter-button');
    els.facets = document.getElementById('algolia-search-page-facets');
    els.applyFilters = document.getElementById('algolia-search-page-apply-filters');
    els.clearFilters = document.getElementById('algolia-search-page-clear-filters');
    els.activeFacets = document.getElementById('algolia-search-page-active-facets');
    els.products = {
      list: document.getElementById('algolia-search-page-products'),
      empty: document.getElementById('algolia-search-page-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-load-more')
    };
    els.series = {
      list: document.getElementById('algolia-search-page-series'),
      empty: document.getElementById('algolia-search-page-series-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-series-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-series-load-more')
    };
    els.brands = {
      list: document.getElementById('algolia-search-page-brands'),
      empty: document.getElementById('algolia-search-page-brands-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-brands-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-brands-load-more')
    };
    els.stores = {
      list: document.getElementById('algolia-search-page-stores'),
      empty: document.getElementById('algolia-search-page-stores-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-stores-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-stores-load-more')
    };
    els.categories = {
      list: document.getElementById('algolia-search-page-categories'),
      empty: document.getElementById('algolia-search-page-categories-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-categories-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-categories-load-more')
    };
    els.editorials = {
      list: document.getElementById('algolia-search-page-editorials'),
      empty: document.getElementById('algolia-search-page-editorials-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-editorials-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-editorials-load-more')
    };
    els.teamPicks = {
      list: document.getElementById('algolia-search-page-team-picks'),
      empty: document.getElementById('algolia-search-page-team-picks-empty'),
      loadMoreWrap: document.getElementById('algolia-search-page-team-picks-load-more-wrap'),
      loadMoreButton: document.getElementById('algolia-search-page-team-picks-load-more')
    };
  }

  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  }

  function normalizeValue(value) {
    if (Array.isArray(value)) return normalizeValue(value[0]);
    if (value && typeof value === 'object') return normalizeValue(value.value || value.name || value.title || value.label || '');
    return String(value || '').trim();
  }

  function getValue(object, paths, fallback = '') {
    for (const path of paths) {
      if (object && Object.prototype.hasOwnProperty.call(object, path) && object[path] !== undefined && object[path] !== null && object[path] !== '') return object[path];
      const nested = String(path).split('.').reduce((value, key) => value && value[key] !== undefined ? value[key] : undefined, object);
      if (nested !== undefined && nested !== null && nested !== '') return nested;
    }
    return fallback;
  }

  const Shared = window.DUKAlgoliaShared;
  if (!Shared) {
    console.error('[DUK Algolia search page] shared logic is missing');
    return;
  }

  window.__dukAlgoliaSearchPageInitialized = true;

  const {
    getLanguage,
    translate,
    localizePath,
    localizeHitUrl,
    buildIndexCandidates,
    formatProductPrice
  } = Shared;

  function getInitialQuery() {
    return new URLSearchParams(window.location.search).get('q')?.trim() || '';
  }

  function getRequestedTab() {
    const tab = new URLSearchParams(window.location.search).get('tab');
    const aliases = {
      product: 'products',
      products: 'products',
      series: 'series',
      serien: 'series',
      brands: 'brands',
      marken: 'brands',
      brand: 'brands',
      stores: 'stores',
      store: 'stores',
      geschaefte: 'stores',
      geschäfte: 'stores',
      shops: 'stores',
      categories: 'categories',
      kategorien: 'categories',
      category: 'categories',
      editorial: 'editorials',
      editorials: 'editorials',
      edits: 'editorials',
      edit: 'editorials',
      teamPicks: 'teamPicks',
      'team-picks': 'teamPicks',
      teampicks: 'teamPicks'
    };
    const normalizedTab = String(tab || '').toLowerCase();
    if (Object.prototype.hasOwnProperty.call(aliases, tab)) return aliases[tab];
    if (Object.prototype.hasOwnProperty.call(aliases, normalizedTab)) return aliases[normalizedTab];
    return '';
  }

  function getProductIndexCandidates() { return buildIndexCandidates('products'); }
  function getCollectionIndexCandidates() { return buildIndexCandidates('collections'); }
  function getStoreIndexCandidates() { return buildIndexCandidates('stores'); }

  function getFacetAttributesToRequest() {
    return [...CONFIG.facets.flatMap((facet) => facet.candidates), ...CONFIG.inStockCandidates];
  }

  function getCollectionType(hit) {
    return normalizeValue(getValue(hit, ['meta.custom.collection_type', 'metafields.custom.collection_type', 'collection_type']));
  }

  async function getAlgoliaClient() {
    if (state.client) return state.client;

    const startedAt = Date.now();
    while (Date.now() - startedAt < CONFIG.timeout) {
      const config = [window.algoliaShopify?.config, window.algoliaShopify, window.algoliaConfig, window.AlgoliaConfig, window.algolia, window.Algolia]
        .filter(Boolean)
        .find((candidate) => (candidate.app_id || candidate.application_id || candidate.appId) && (candidate.search_api_key || candidate.search_only_api_key || candidate.searchApiKey || candidate.apiKey));
      const algoliaSearch = window.algoliasearch || window.algoliaShopify?.externals?.algoliasearch;

      if (config && typeof algoliaSearch === 'function') {
        const appId = config.app_id || config.application_id || config.appId;
        const searchKey = config.search_api_key || config.search_only_api_key || config.searchApiKey || config.apiKey;
        state.client = algoliaSearch(appId, searchKey);
        return state.client;
      }

      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    throw new Error('Algolia client/config not available');
  }

  async function searchFirstAvailableIndex(client, indexNames, query, options) {
    let last = { indexName: '', hits: [], nbHits: 0, nbPages: 0, facets: {} };

    for (const indexName of indexNames) {
      try {
        const result = await client.initIndex(indexName).search(query, options);
        last = {
          indexName,
          hits: result?.hits || [],
          nbHits: result?.nbHits || 0,
          nbPages: result?.nbPages || 0,
          facets: result?.facets || {}
        };
        log('searched', indexName, last.hits.length, 'of', last.nbHits);
        return last;
      } catch (error) {
        warn('index failed', indexName, error?.message || error);
      }
    }

    return last;
  }

  function getFacetFilters() {
    return CONFIG.facets.reduce((filters, facet) => {
      const values = state.selectedFacets[facet.key] || [];
      if (!values.length) return filters;
      const attribute = state.activeFacetAttributes[facet.key] || facet.candidates[0];
      filters.push(values.map((value) => `${attribute}:${value}`));
      return filters;
    }, []);
  }

  function getFiltersString() {
    if (!state.inStock) return undefined;
    const inStockAttribute = CONFIG.inStockCandidates.find((candidate) => state.lastFacets?.[candidate]) || CONFIG.inStockCandidates[0];
    return `${inStockAttribute}:true OR ${inStockAttribute}:1`;
  }

  function getImage(hit) {
    const image = getValue(hit, ['image', 'storefront', 'product_image', 'featured_image', 'image_url', 'thumbnail_url', 'image.src', 'featured_image.src']);
    if (Array.isArray(hit.image_urls) && hit.image_urls[0]) return hit.image_urls[0];
    if (typeof image === 'string') return image;
    return image?.src || '';
  }

  function getSizedImageUrl(imageUrl, width) {
    if (!imageUrl) return '';

    try {
      const url = new URL(imageUrl, window.location.origin);
      const isShopifyCdn = /(^|\.)cdn\.shopify\.com$/i.test(url.hostname)
        || /(^|\.)shopifycdn\.com$/i.test(url.hostname);

      if (!isShopifyCdn) return imageUrl;

      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_error) {
      return imageUrl;
    }
  }

  function renderImageAttributes(imageUrl) {
    const standardUrl = escapeHtml(getSizedImageUrl(imageUrl, 400));
    const retinaUrl = escapeHtml(getSizedImageUrl(imageUrl, 800));
    return `src="${standardUrl}" srcset="${standardUrl} 1x, ${retinaUrl} 2x" width="400"`;
  }

  function buildProductUrl(hit) {
    const directUrl = getValue(hit, ['url', 'product_url']);
    const handle = getValue(hit, ['handle', 'product_handle']);
    return directUrl || handle ? localizeHitUrl(directUrl, `/products/${handle}`) : '#';
  }

  function buildCollectionUrl(hit) {
    const directUrl = getValue(hit, ['url', 'collection_url']);
    const handle = getValue(hit, ['handle', 'collection_handle']);
    return directUrl || handle ? localizeHitUrl(directUrl, `/collections/${handle}`) : '#';
  }

  function buildStoreUrl(hit) {
    const directUrl = getValue(hit, ['url', 'store_url']);
    const handle = getValue(hit, ['handle', 'store_handle', 'objectID']);
    return directUrl || handle ? localizeHitUrl(directUrl, `/pages/stores/${handle}`) : '#';
  }


  function renderProductCard(hit, index) {
    const title = escapeHtml(getValue(hit, ['title', 'name', 'product_title']));
    const vendor = escapeHtml(getValue(hit, ['vendor', 'brand']));
    const image = getImage(hit);
    const url = escapeHtml(buildProductUrl(hit));
    const price = escapeHtml(formatProductPrice(hit));
    const handle = escapeHtml(getValue(hit, ['handle', 'product_handle', 'objectID']));
    const isEagerImage = index < 8;
    const isPriorityImage = index < 4;
    const imageLoading = isEagerImage ? 'eager' : 'lazy';
    const imagePriority = isPriorityImage ? ' fetchpriority="high"' : '';
    const imageDecoding = isPriorityImage ? 'sync' : 'async';

    return `<product-card class="product-card product-card--info-outside product-card--blends color-scheme color-scheme--scheme-1" handle="${handle}">
      <div class="product-card__figure">
        <a href="${url}" class="product-card__media">${image ? `<img ${renderImageAttributes(image)} alt="${title}" class="product-card__image product-card__image--primary" loading="${imageLoading}"${imagePriority} decoding="${imageDecoding}">` : ''}</a>
      </div>
      <div class="product-card__info product-card__info--flush">
        <div class="v-stack justify-items-start text-start">
          <div class="v-stack gap-0.5">
            ${vendor ? `<span class="vendor text-sm">${vendor}</span>` : ''}
            <a href="${url}" class="product-title subheading line-clamp" style="--line-clamp-count: 2">${title}</a>
          </div>
          ${price ? `<price-list class="price-list"><sale-price class="subheading">${price}</sale-price></price-list>` : ''}
        </div>
      </div>
    </product-card>`;
  }

  function renderCollectionCard(hit, tab, index) {
    const title = escapeHtml(getValue(hit, ['meta.custom.title_short', 'metafields.custom.title_short', 'title_short', 'title', 'name']));
    const vendor = tab === 'series' ? escapeHtml(normalizeValue(getValue(hit, ['meta.custom.vendor', 'metafields.custom.vendor', 'custom.vendor', 'vendor']))) : '';
    const image = getImage(hit);
    const url = escapeHtml(tab === 'stores' ? buildStoreUrl(hit) : buildCollectionUrl(hit));
    const imageLoading = index < 4 ? 'eager' : 'lazy';

    return `<a href="${url}" class="algolia-search-page__collection-card group">
      <div class="algolia-search-page__collection-card-media">${image ? `<img ${renderImageAttributes(image)} alt="${title}" loading="${imageLoading}" decoding="async">` : ''}</div>
      <div class="algolia-search-page__collection-card-info">
        ${vendor ? `<span class="vendor text-sm">${vendor}</span>` : ''}
        <span class="product-title subheading line-clamp" style="--line-clamp-count: 2">${title}</span>
      </div>
    </a>`;
  }

  function renderCollectionLink(hit) {
    const title = escapeHtml(getValue(hit, ['meta.custom.title_short', 'metafields.custom.title_short', 'title_short', 'title', 'name']));
    const url = escapeHtml(buildCollectionUrl(hit));
    return `<li><a href="${url}" class="link-reversed h3">${title}</a></li>`;
  }

  function renderCheckbox(facet, value, count, index) {
    const id = `algolia-filter-${facet.key}-${index}`;
    const selectedValues = state.selectedFacets[facet.key] || [];
    const checked = selectedValues.includes(value);

    return `<div class="checkbox-control">
      <input id="${escapeHtml(id)}" class="checkbox" type="checkbox" data-algolia-facet-key="${escapeHtml(facet.key)}" value="${escapeHtml(value)}" ${checked ? 'checked' : ''}>
      <label for="${escapeHtml(id)}">${escapeHtml(value)} <span class="text-subdued">(${count})</span></label>
    </div>`;
  }

  function renderAccordion(title, content, open = false) {
    return `<accordion-disclosure class="accordion">
      <details class="accordion__disclosure" ${open ? 'open' : ''}>
        <summary class="accordion__summary subheading">
          <span>${escapeHtml(title)}</span>
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-accordion-small-arrow" viewBox="0 0 10 6"><path d="m1 1 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg>
        </summary>
        <div class="accordion__content">${content}</div>
      </details>
    </accordion-disclosure>`;
  }

  function getAvailableFacet(facet, facets) {
    const attribute = facet.candidates.find((candidate) => facets[candidate] && Object.keys(facets[candidate]).length > 0);
    if (attribute) state.activeFacetAttributes[facet.key] = attribute;
    return attribute;
  }

  function renderFacetControls(facets = {}) {
    if (!els.facets) return;
    const blocks = [];

    CONFIG.facets.forEach((facet) => {
      const attribute = getAvailableFacet(facet, facets) || state.activeFacetAttributes[facet.key];
      const values = attribute ? facets[attribute] : null;
      if (!values) return;

      const content = `<div class="v-stack gap-2.5">${Object.entries(values)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 20)
        .map(([value, count], index) => renderCheckbox(facet, value, count, index))
        .join('')}</div>`;

      blocks.push(renderAccordion(translate(facet.label), content, Boolean((state.selectedFacets[facet.key] || []).length)));
    });

    const inStockAttribute = CONFIG.inStockCandidates.find((candidate) => facets[candidate]);
    if (inStockAttribute || state.inStock) {
      const id = 'algolia-search-page-in-stock';
      const content = `<div class="facets__availability-control">
        <label for="${id}" class="subheading">${translate({ de: 'Nur lagernde Artikel', en: 'In stock only' })}</label>
        <input id="${id}" type="checkbox" class="switch" role="switch" ${state.inStock ? 'checked' : ''}>
      </div>`;
      blocks.push(renderAccordion(translate({ de: 'Verfügbarkeit', en: 'Availability' }), content, state.inStock));
    }

    els.facets.innerHTML = blocks.length ? blocks.join('') : `<p class="text-sm text-subdued algolia-search-page__filter-empty">${translate({ de: 'Keine Filter verfügbar.', en: 'No filters available.' })}</p>`;
    updateFilterButtonVisibility();
  }

  function renderActiveFacets() {
    if (!els.activeFacets) return;
    const chips = [];

    CONFIG.facets.forEach((facet) => {
      (state.selectedFacets[facet.key] || []).forEach((value) => {
        chips.push(`<button type="button" class="removable-facet subheading" data-remove-facet-key="${escapeHtml(facet.key)}" data-remove-facet-value="${escapeHtml(value)}">${escapeHtml(value)}<span class="tap-area tap-area--sm">×</span></button>`);
      });
    });

    if (state.inStock) {
      chips.push(`<button type="button" class="removable-facet subheading" data-remove-stock>${translate({ de: 'Auf Lager', en: 'In stock' })}<span class="tap-area tap-area--sm">×</span></button>`);
    }

    els.activeFacets.innerHTML = chips.join('');
    els.activeFacets.hidden = chips.length === 0 || state.activeTab !== 'products';
  }

  function collectFilterStateFromDrawer() {
    const selectedFacets = {};
    document.querySelectorAll('[data-algolia-facet-key]:checked').forEach((input) => {
      const key = input.dataset.algoliaFacetKey;
      if (!selectedFacets[key]) selectedFacets[key] = [];
      selectedFacets[key].push(input.value);
    });

    state.selectedFacets = selectedFacets;
    state.inStock = Boolean(document.getElementById('algolia-search-page-in-stock')?.checked);
  }

  function closeFilterDrawer() {
  const drawer = document.getElementById('facets-drawer');
  if (!drawer) return;

  if (typeof drawer.hide === 'function') {
    drawer.hide();
    return;
  }

  if (typeof drawer.close === 'function') {
    drawer.close();
    return;
  }

  const closeButton = drawer.querySelector(
    '[aria-controls="facets-drawer"], [data-close], button[is="close-button"]'
  );

  if (closeButton) {
    closeButton.click();
    return;
  }

  drawer.removeAttribute('open');
  drawer.setAttribute('aria-hidden', 'true');
}

  function tabState(tab) {
    return state[tab];
  }

  function tabLabel(tab) {
    return translate(CONFIG.tabs.find((entry) => entry.key === tab)?.label || tab);
  }

  function firstVisibleTab() {
    return CONFIG.tabs.find((tab) => tabState(tab.key).nbHits > 0)?.key || 'products';
  }

  function updateCount() {
    if (!els.count) return;
    const language = getLanguage();

    if (!state.query) {
      els.count.textContent = language === 'de' ? 'Bitte gib einen Suchbegriff ein.' : 'Please enter a search term.';
      return;
    }

    const count = tabState(state.activeTab).nbHits || 0;
    const noun = tabLabel(state.activeTab).toLowerCase();
    els.count.textContent = `${count} ${noun} ${language === 'de' ? 'für' : 'for'} “${state.query}”`;
  }

  function updateFilterButtonVisibility() {
    if (!els.filterButton) return;
    const hasFacetControls = Boolean(els.facets?.children?.length) && !els.facets?.querySelector('.algolia-search-page__filter-empty');
    const hasActiveFilters = Object.values(state.selectedFacets).some((values) => values.length > 0) || state.inStock;
    els.filterButton.hidden = state.activeTab !== 'products' || (!hasFacetControls && !hasActiveFilters);
  }

  function renderTabs() {
    const configuredTabs = new Set(CONFIG.tabs.map((tab) => tab.key));

    document.querySelectorAll('[data-algolia-search-tab]').forEach((button) => {
      if (!configuredTabs.has(button.dataset.algoliaSearchTab)) button.hidden = true;
    });

    document.querySelectorAll('[data-algolia-search-panel]').forEach((panel) => {
      if (!configuredTabs.has(panel.dataset.algoliaSearchPanel)) panel.hidden = true;
    });

    CONFIG.tabs.forEach((tab) => {
      const button = document.querySelector(`[data-algolia-search-tab="${tab.key}"]`);
      const panel = document.querySelector(`[data-algolia-search-panel="${tab.key}"]`);
      const hasActiveFilters =
        Object.values(state.selectedFacets).some((values) => values.length > 0) ||
        state.inStock;

      const hasResults =
        tabState(tab.key).nbHits > 0 ||
        (tab.key === 'products' && hasActiveFilters);

      if (button) {
        button.hidden = !hasResults;
        button.setAttribute('aria-selected', String(tab.key === state.activeTab && hasResults));
      }

      if (panel) {
        panel.hidden = tab.key !== state.activeTab || !hasResults;
      }
    });
  }

  function setActiveTab(tab, options = {}) {
    const hasActiveFilters =
      Object.values(state.selectedFacets).some((values) => values.length > 0) ||
      state.inStock;

    if (!tabState(tab)?.nbHits && !(tab === 'products' && hasActiveFilters)) {
      tab = firstVisibleTab();
    }
    state.activeTab = tab;
    if (options.updateUrl !== false) updateUrl(state.query, 'replace');
    renderTabs();
    renderActiveFacets();
    updateFilterButtonVisibility();
    updateCount();
  }

  function resetPanels() {
    CONFIG.tabs.map((tab) => tab.key).forEach((tab) => {
      if (els[tab]?.list) els[tab].list.innerHTML = '';
      if (els[tab]?.empty) els[tab].empty.hidden = true;
      if (els[tab]?.loadMoreWrap) els[tab].loadMoreWrap.hidden = true;
    });
  }

  function renderProducts({ append = false } = {}) {
    if (!els.products.list) return;
    if (!append) els.products.list.innerHTML = '';

    const offset = state.products.page * CONFIG.hitsPerPage;
    const hits = append ? state.products.hits.slice(offset, offset + CONFIG.hitsPerPage) : state.products.hits;
    const startIndex = append ? offset : 0;

    els.products.list.insertAdjacentHTML('beforeend', hits.map((hit, index) => renderProductCard(hit, startIndex + index)).join(''));
    if (els.products.empty) els.products.empty.hidden = state.products.nbHits > 0;
    if (els.products.loadMoreWrap) els.products.loadMoreWrap.hidden = state.products.page + 1 >= state.products.nbPages || state.products.nbHits <= state.products.hits.length;
  }

  function renderCollections(tab, { append = false } = {}) {
    const container = els[tab];
    if (!container?.list) return;
    if (!append) container.list.innerHTML = '';

    const offset = state[tab].page * CONFIG.hitsPerPage;
    const hits = state[tab].hits.slice(offset, offset + CONFIG.hitsPerPage);

    const renderer = tab === 'categories' ? renderCollectionLink : (hit, index) => renderCollectionCard(hit, tab, offset + index);
    container.list.insertAdjacentHTML('beforeend', hits.map(renderer).join(''));
    if (container.empty) container.empty.hidden = state[tab].nbHits > 0;
    if (container.loadMoreWrap) container.loadMoreWrap.hidden = offset + hits.length >= state[tab].nbHits;
  }


  function renderAllPanels() {
    renderProducts({ append: false });
    renderCollections('series', { append: false });
    renderCollections('brands', { append: false });
    renderCollections('stores', { append: false });
    renderCollections('categories', { append: false });
    renderCollections('editorials', { append: false });
    renderCollections('teamPicks', { append: false });
    renderTabs();
    renderActiveFacets();
    updateFilterButtonVisibility();
    updateCount();
  }

  function updateUrl(query, mode = 'replace') {
    const url = new URL(window.location.href);
    if (query) url.searchParams.set('q', query);
    else url.searchParams.delete('q');
    if (state.activeTab && state.activeTab !== 'products') url.searchParams.set('tab', state.activeTab);
    else url.searchParams.delete('tab');
    url.searchParams.delete('page');
    const method = mode === 'push' ? 'pushState' : 'replaceState';
    window.history[method]({}, '', url.toString());
  }

  function setLoading(isLoading) {
    els.root?.classList.toggle('is-loading', Boolean(isLoading));
    if (isLoading && els.count && !tabState(state.activeTab)?.nbHits) {
      els.count.textContent = getLanguage() === 'de' ? 'Suche läuft…' : 'Searching…';
    }
  }

  async function runSearch(query, options = {}) {
    const normalizedQuery = String(query || '').trim();
    const requestId = ++state.requestId;
    state.query = normalizedQuery;

    if (options.updateUrl !== false) updateUrl(normalizedQuery, options.urlMode || 'replace');

    setLoading(Boolean(normalizedQuery));

    if (!normalizedQuery) {
      resetPanels();
      state.products = { page: 0, nbHits: 0, nbPages: 0, hits: [], activeIndexName: '' };
      state.series = { page: 0, nbHits: 0, hits: [], activeIndexName: '' };
      state.brands = { page: 0, nbHits: 0, hits: [], activeIndexName: '' };
      state.stores = { page: 0, nbHits: 0, nbPages: 0, hits: [], activeIndexName: '' };
      state.categories = { page: 0, nbHits: 0, hits: [], activeIndexName: '' };
      state.editorials = { page: 0, nbHits: 0, hits: [], activeIndexName: '' };
      state.teamPicks = { page: 0, nbHits: 0, hits: [], activeIndexName: '' };
      state.activeTab = 'products';
      renderAllPanels();
      updateCount();
      setLoading(false);
      return;
    }

    const client = await getAlgoliaClient();

    const [productsResult, collectionsResult, storesResult] = await Promise.all([
      searchFirstAvailableIndex(client, getProductIndexCandidates(), normalizedQuery, {
        hitsPerPage: CONFIG.hitsPerPage,
        page: 0,
        clickAnalytics: true,
        facets: getFacetAttributesToRequest(),
        facetFilters: getFacetFilters(),
        filters: getFiltersString()
      }),
      searchFirstAvailableIndex(client, getCollectionIndexCandidates(), normalizedQuery, {
        hitsPerPage: CONFIG.collectionHitsPerPage,
        clickAnalytics: true
      }),
      searchFirstAvailableIndex(client, getStoreIndexCandidates(), normalizedQuery, {
        hitsPerPage: CONFIG.hitsPerPage,
        page: 0,
        clickAnalytics: true
      })
    ]);

    if (requestId !== state.requestId) return;

    state.products = {
      page: 0,
      nbHits: productsResult.nbHits,
      nbPages: productsResult.nbPages,
      hits: productsResult.hits,
      activeIndexName: productsResult.indexName
    };

    state.lastFacets = productsResult.facets;
    renderFacetControls(productsResult.facets);

    const collectionHits = collectionsResult.hits;
    state.series = {
      page: 0,
      nbHits: 0,
      hits: collectionHits.filter((hit) => getCollectionType(hit) === 'series'),
      activeIndexName: collectionsResult.indexName
    };
    state.series.nbHits = state.series.hits.length;

    state.brands = {
      page: 0,
      nbHits: 0,
      hits: collectionHits.filter((hit) => getCollectionType(hit) === 'vendor'),
      activeIndexName: collectionsResult.indexName
    };
    state.brands.nbHits = state.brands.hits.length;

    const categoryTypes = ['category', 'scent-family', 'type', 'primary-note', 'season', 'note'];
    state.categories = {
      page: 0,
      nbHits: 0,
      hits: collectionHits.filter((hit) => categoryTypes.includes(getCollectionType(hit))),
      activeIndexName: collectionsResult.indexName
    };
    state.categories.nbHits = state.categories.hits.length;

    state.editorials = {
      page: 0,
      nbHits: 0,
      hits: collectionHits.filter((hit) => getCollectionType(hit) === 'edit'),
      activeIndexName: collectionsResult.indexName
    };
    state.editorials.nbHits = state.editorials.hits.length;

    state.teamPicks = {
      page: 0,
      nbHits: 0,
      hits: collectionHits.filter((hit) => getCollectionType(hit) === 'team-picks'),
      activeIndexName: collectionsResult.indexName
    };
    state.teamPicks.nbHits = state.teamPicks.hits.length;

    state.stores = {
      page: 0,
      nbHits: storesResult.nbHits,
      nbPages: storesResult.nbPages,
      hits: storesResult.hits,
      activeIndexName: storesResult.indexName
    };


    log('collection raw', collectionsResult.indexName, collectionHits.length, 'types', [...new Set(collectionHits.map(getCollectionType).filter(Boolean))]);

    const hasActiveFilters =
      Object.values(state.selectedFacets).some((values) => values.length > 0) ||
      state.inStock;

    state.activeTab =
      tabState(state.activeTab).nbHits > 0 ||
      (state.activeTab === 'products' && hasActiveFilters)
        ? state.activeTab
        : firstVisibleTab();
    renderAllPanels();
    setLoading(false);
  }

  async function loadMoreProducts() {
    if (state.products.page + 1 >= state.products.nbPages || !state.products.activeIndexName) return;

    const nextPage = state.products.page + 1;
    const client = await getAlgoliaClient();
    const result = await searchFirstAvailableIndex(client, [state.products.activeIndexName], state.query, {
      hitsPerPage: CONFIG.hitsPerPage,
      page: nextPage,
      clickAnalytics: true,
      facets: getFacetAttributesToRequest(),
      facetFilters: getFacetFilters(),
      filters: getFiltersString()
    });

    if (result.indexName !== state.products.activeIndexName) {
      throw new Error('Could not load the next product page');
    }

    if (!result.hits.length) {
      state.products.nbPages = nextPage;
      renderProducts({ append: false });
      return;
    }

    state.products.page = nextPage;
    state.products.hits = [...state.products.hits, ...result.hits];
    renderProducts({ append: true });
  }


  async function loadMoreStores() {
    if (state.stores.page + 1 >= state.stores.nbPages || !state.stores.activeIndexName) return;

    const nextPage = state.stores.page + 1;
    const client = await getAlgoliaClient();
    const result = await searchFirstAvailableIndex(client, [state.stores.activeIndexName], state.query, {
      hitsPerPage: CONFIG.hitsPerPage,
      page: nextPage,
      clickAnalytics: true
    });

    if (result.indexName !== state.stores.activeIndexName) {
      throw new Error('Could not load the next store page');
    }

    if (!result.hits.length) {
      state.stores.nbPages = nextPage;
      renderCollections('stores', { append: false });
      return;
    }

    state.stores.page = nextPage;
    state.stores.hits = [...state.stores.hits, ...result.hits];
    renderCollections('stores', { append: true });
  }

  function loadMoreCollections(tab) {
    state[tab].page += 1;
    renderCollections(tab, { append: true });
  }

  function debounce(callback, delay) {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => callback(...args), delay);
    };
  }

  function bindEvents() {
    const debouncedRunSearch = debounce((value) => {
      runSearch(value, { urlMode: 'replace' }).catch((error) => warn('live search failed', error?.message || error));
    }, CONFIG.debounceMs);

    els.input?.addEventListener('input', (event) => {
      debouncedRunSearch(event.target.value);
    });

    els.input?.closest('form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      runSearch(els.input.value, { urlMode: 'push' }).catch((error) => warn('submitted search failed', error?.message || error));
    });

    document.querySelectorAll('[data-algolia-search-tab]').forEach((button) => {
      button.addEventListener('click', () => setActiveTab(button.dataset.algoliaSearchTab));
    });

    els.products.loadMoreButton?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        await loadMoreProducts();
      } catch (error) {
        warn('load more products failed', error?.message || error);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });

    els.series.loadMoreButton?.addEventListener('click', (event) => {
      event.currentTarget.disabled = true;
      try { loadMoreCollections('series'); } finally { event.currentTarget.disabled = false; }
    });

    els.brands.loadMoreButton?.addEventListener('click', (event) => {
      event.currentTarget.disabled = true;
      try { loadMoreCollections('brands'); } finally { event.currentTarget.disabled = false; }
    });

    els.stores.loadMoreButton?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        await loadMoreStores();
      } catch (error) {
        warn('load more stores failed', error?.message || error);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });

    els.categories.loadMoreButton?.addEventListener('click', (event) => {
      event.currentTarget.disabled = true;
      try { loadMoreCollections('categories'); } finally { event.currentTarget.disabled = false; }
    });

    els.editorials.loadMoreButton?.addEventListener('click', (event) => {
      event.currentTarget.disabled = true;
      try { loadMoreCollections('editorials'); } finally { event.currentTarget.disabled = false; }
    });

    els.teamPicks.loadMoreButton?.addEventListener('click', (event) => {
      event.currentTarget.disabled = true;
      try { loadMoreCollections('teamPicks'); } finally { event.currentTarget.disabled = false; }
    });



    els.applyFilters?.addEventListener('click', () => {
      collectFilterStateFromDrawer();
      closeFilterDrawer();

      runSearch(state.query, { updateUrl: false }).catch((error) =>
        warn('filter search failed', error?.message || error)
      );
    });

    els.clearFilters?.addEventListener('click', () => {
      state.selectedFacets = {};
      state.inStock = false;

      document.querySelectorAll('[data-algolia-facet-key]').forEach((input) => {
        input.checked = false;
      });

      const stockInput = document.getElementById('algolia-search-page-in-stock');
      if (stockInput) stockInput.checked = false;

      closeFilterDrawer();

      runSearch(state.query, { updateUrl: false }).catch((error) =>
        warn('clear filters failed', error?.message || error)
      );
    });

    els.activeFacets?.addEventListener('click', (event) => {
      const facetButton = event.target.closest('[data-remove-facet-key]');
      const stockButton = event.target.closest('[data-remove-stock]');

      if (facetButton) {
        const key = facetButton.dataset.removeFacetKey;
        const values = state.selectedFacets[key] || [];
        state.selectedFacets[key] = values.filter((value) => value !== facetButton.dataset.removeFacetValue);
      }

      if (stockButton) state.inStock = false;

      if (facetButton || stockButton) {
        runSearch(state.query, { updateUrl: false }).catch((error) => warn('active facet removal failed', error?.message || error));
      }
    });

    window.addEventListener('popstate', () => {
      const query = getInitialQuery();
      const requestedTab = getRequestedTab();
      if (requestedTab) state.activeTab = requestedTab;
      if (els.input) els.input.value = query;
      runSearch(query, { updateUrl: false }).catch((error) => warn('popstate search failed', error?.message || error));
    });
  }

  async function init() {
    cacheElements();
    if (!els.root || els.root.dataset.algoliaSearchInitialized === 'true') return;
    els.root.dataset.algoliaSearchInitialized = 'true';

    injectStyles();
    bindEvents();

    const query = getInitialQuery();
    state.query = query;
    state.activeTab = getRequestedTab() || state.activeTab;
    if (els.input && els.input.value !== query) els.input.value = query;

    await runSearch(query, { updateUrl: false });
  }

  function initializeSearchPage() {
    init().catch((error) => {
      warn('search page failed', error?.message || error);
      if (els.count) els.count.textContent = getLanguage() === 'de' ? 'Beim Laden der Suche ist ein Fehler aufgetreten.' : 'There was an error loading search results.';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchPage, { once: true });
  } else {
    initializeSearchPage();
  }

  document.addEventListener('shopify:section:load', initializeSearchPage);
})();
